<template>
  <div>
    <beautiful-chat
      :participants="participants"
      :titleImageUrl="titleImageUrl"
      :onMessageWasSent="onMessageWasSent"
      :messageList="chatMessages"
      :newMessagesCount="newMessagesCount"
      :isOpen="isChatOpen"
      :close="closeChat"
      :icons="icons"
      :open="openChat"
      :showEmoji="true"
      :showFile="false"
      :showTypingIndicator="showTypingIndicator"
      :colors="colors"
      :alwaysScrollToBottom="alwaysScrollToBottom"
      :messageStyling="messageStyling"
    >
      <template v-slot:header>
        <b-img
          :src="guide.user ? guide.user.imgURL : ''"
          rounded="circle"
          :alt="`${guide.user.firstname} ${guide.user.lastname}`"
          style="height: 55px"
        >
        </b-img>
        <h6 class="ml-2 mt-3">Ask {{ guide.user.firstname }} Anything!</h6>
      </template>
    </beautiful-chat>
  </div>
</template>

<script>
import Vue from "vue";
import Chat from "vue-beautiful-chat";
import RecordViews from "@/mixins/RecordViews";
//import CloseIcon from "vue-beautiful-chat/src/assets/close-icon.png";
//import OpenIcon from "vue-beautiful-chat/src/assets/logo-no-bg.svg";
//import FileIcon from "vue-beautiful-chat/src/assets/file.svg";
//import CloseIconSvg from "vue-beautiful-chat/src/assets/close.svg";
import { mapGetters } from "vuex";
const axios = require("axios");
//const dialogflowURL =
//"https://us-central1-journeybinder.cloudfunctions.net/dialogflowGateway";
const dialogflowURL =
  "https://us-central1-myjourneybinderdev.cloudfunctions.net/dialogflowGateway";
//https://us-central1-myjourneybinderdev.cloudfunctions.net/dialogflowWebhook

Vue.use(Chat);

export default {
  name: "chat",
  props: {
    ip: {
      type: String,
      required: true
    },
    guide: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isFirstEntry: true,
      audios: {
        sendMsg: {
          audio: null,
          file: "resources/audios/sendmsg.mp3"
        },
        receivedMsg: {
          audio: null,
          file: "resources/audios/sendmsg.mp3"
        },
        newUnseenMsg: {
          audio: null,
          file: "resources/audios/sendmsg.mp3"
        }
      },
      icons: {
        open: {
          img: null, //OpenIcon,
          name: "default"
        },
        close: {
          img: null, //CloseIcon,
          name: "default"
        },
        file: {
          img: null, //FileIcon,
          name: "default"
        },
        closeSvg: {
          img: null, //CloseIconSvg,
          name: "default"
        }
      },
      participants: [
        ///May need to move to computed
        {
          //Guide
          id: this.guide.user ? this.guide.user.userId : null,
          name: this.guide.user ? this.guide.user.firstname : "Guide",
          imageUrl: this.guide.user ? this.guide.user.imgURL : ""
        },
        {
          //User
          id: this.user ? this.user.userId : this.sessionId,
          name: this.user ? this.user.firstname : "User",
          imageUrl: this.user ? this.user.imgURL : ""
        },
        {
          //Bot
          id: "bot",
          name: "Bot",
          imageUrl: "assets/images/bot.png"
        }
      ], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
      titleImageUrl: this.guide.user ? this.guide.user.imgURL : "",
      isChatOpen: false, // to determine whether the chat window should be open or closed
      showTypingIndicator: "", // when set to a value matching the participant.id it shows the typing indicator for the specific user
      colors: {
        header: {
          bg: "#547efb",
          text: "#ffffff"
        },
        launcher: {
          bg: "#547efb"
        },
        messageList: {
          bg: "#ffffff"
        },
        sentMessage: {
          bg: "#4e8cff",
          text: "#ffffff"
        },
        receivedMessage: {
          bg: "#eaeaea",
          text: "#222222"
        },
        userInput: {
          bg: "#f4f7f9",
          text: "#565867"
        }
      }, // specifies the color scheme for the component
      alwaysScrollToBottom: true, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
      messageStyling: true, // enables *bold* /emph/ _underline_ and such (more info at github.com/mattezza/msgdown)
      messagesOnClose: [],
      sessionId: null
    };
  },
  mixins: [RecordViews],
  mounted() {
    this.sessionId = this.checkSession("chat_guidebot");
    if (this.sessionId) {
      this.getChat(this.sessionId);
    }
    this.audios.sendMsg.audio = new Audio(this.audios.sendMsg.file);
  },
  computed: {
    ...mapGetters({
      chat: "listings/guideChat",
      user: "user/user",
      profile: "user/profile"
    }),
    chatMessages() {
      var chat = [];
      if (this.chat && this.chat.messages) {
        this.chat.messages.forEach(obj => {
          if (obj.author === this.sessionId) {
            obj.author = "me";
          }
          chat.push(obj);
        });
        return chat;
      }
      return [];
    },
    newMessagesCount() {
      return this.chatMessages.length - this.messagesOnClose.length;
    }
  },
  methods: {
    sendMessage(text) {
      /*May be able to remove*/
      if (text.length > 0) {
        this.newMessagesCount = this.isChatOpen
          ? this.newMessagesCount
          : this.newMessagesCount + 1;
        this.onMessageWasSent({
          author: "support",
          type: "text",
          data: { text }
        });
      }
    },
    getBotResponse(text) {
      if (text) {
        //BOT RESPONSE
        ///SEND TO DIALOGFLOW
        // Make the request- Place in the store
        axios({
          method: "post",
          url: dialogflowURL,
          data: {
            sessionId: this.sessionId,
            queryInput: {
              text: {
                text: text,
                languageCode: "en-US"
              }
            }
          }
        })
          .then(res => {
            const { fulfillmentText } = res;
            let message = {
              _created_at: new Date(),
              ip: this.ip,
              page: window.location.href,
              author: "bot",
              type: "text",
              data: { fulfillmentText }
            };
            let payload = {
              guideId:
                this.guide && this.guide.user ? this.guide.user.userId : "",
              message: message
            };
            this.$store
              .dispatch("listings/addGuideMsg", payload)
              .then(() => {
                if (this.audios.sendMsg.audio) {
                  this.audios.sendMsg.audio.play();
                }
              })
              .catch(error => {
                console.log(error);
              });
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    onMessageWasSent(message) {
      message._created_at = new Date();
      message.ip = this.ip;
      message.page = window.location.href;
      message.author = this.sessionId;
      let payload = {
        guideId: this.guide.user.userId,
        message: message
      };
      this.$store
        .dispatch("listings/addGuideMsg", payload)
        .then(() => {
          if (this.audios.sendMsg.audio) {
            this.audios.sendMsg.audio.play();
          }
        })
        .catch(error => {
          console.log(error);
        });

      if (message.type === "text" && message.data) {
        this.getBotResponse(message.data.text);
      }
    },
    openChat() {
      this.isChatOpen = true;
      this.messagesOnClose = this.chatMessages;
    },
    closeChat() {
      this.isChatOpen = false;
      this.messagesOnClose = this.chatMessages;
    },
    getChat(botSessionId) {
      let user = {};
      if (this.user) {
        user = {
          firstname: this.user.firstname || "",
          lastname: this.user.lastname || "",
          user: `users/${this.user.uid}`
        };
      } else {
        user = {
          firstname: name.substr(0, name.indexOf(" ")),
          lastname: name.substr(name.indexOf(" ") + 1)
        };
      }
      let identity = {
        ip: this.ip,
        cookie: this.ip.split(".").join("") + new Date().getTime(),
        typing_dna: "dna",
        user: user
      };
      this.$store
        .dispatch("listings/getGuideChat", {
          guideId: this.guide && this.guide.user ? this.guide.user.userId : "",
          identity: identity,
          sessionId: botSessionId
        })
        .then(() => {
          if (this.isFirstEntry) {
            this.isFirstentry = false;
            this.messagesOnClose = this.chatMessages;
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
